import { usePlanningStore } from '@planning/AppProvider'
import { OrderNotesSubForm } from '@planning/pages/Order/V2/organisms/OrderNotesSubForm'
import { OrderFormStoreType } from '@planning/pages/Order/V2/stores/OrderFormStore'
import { useTranslate } from '@tolgee/react'
import { IFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { OrderNotesButton, OrderNotesButtonProps } from '../atoms/OrderNotesButton'

type Props = OrderNotesButtonProps & {
  formStore: IFormStore<OrderFormStoreType>
  initialValues?: Partial<OrderFormStoreType>
  onSaveAdditionalInformation?: () => void
}

export const OrderNotesDialogEditButton: FC<Props> = observer(props => {
  const { t } = useTranslate()
  const { appViewStore } = usePlanningStore()
  const { formStore, initialValues, onSaveAdditionalInformation } = props

  const onClick = async () => {
    const isConfirm = await appViewStore.setOpenConfirmDialog(
      true,
      <OrderNotesSubForm formStore={formStore} initialValues={initialValues} />,
      t('viewNotes', 'View notes'),
      undefined,
      {
        primaryActionText: t('save', 'Save'),
        secondaryActionText: t('cancel', 'Cancel'),
        maxWidth: 'sm',
      },
    )

    if (isConfirm) onSaveAdditionalInformation?.()
  }

  return <OrderNotesButton {...props} onClick={onClick} />
})
